import React from "react";
import { Button, Popover } from "antd";
import Item from "./Item/Item";
import { Container, Header } from "./Styled"
import { Entity } from "../../../../../model/intent/types";
import EntityForm from "../../../entityManager/entityForm/EntityForm";
type EntitySelectorProps = {
    entities: Entity[];
    onSelect: (entity: Entity) => void;
};

const EntitySelector: React.FunctionComponent<EntitySelectorProps> = props => {
  const { entities, onSelect } = props;
  return (
      <Container>
          <Header><Popover trigger="click" content={<div style={{minWidth:'500px'}}><EntityForm/></div>}><Button>Create new Entity</Button></Popover></Header>
          {entities.map((entity) => {
            return <Item onSelect={onSelect} entity={entity} />
          })}
      </Container>
  );
};

export default EntitySelector;
